export default `    <div>
<p style="margin:0pt"><a name="_Hlk48038307"><span
            style="background-color:#ffffff; color:#3f3f3f; font-size:10.5pt; font-weight:bold">【</span><span
            style="background-color:#ffffff; color:#3f3f3f; font-size:10.5pt; font-weight:bold">投保须知</span><span
            style="background-color:#ffffff; color:#3f3f3f; font-size:10.5pt; font-weight:bold">】</span></a>
</p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">1.</span><span
        style=" font-size:10.5pt">本</span><span
        style=" font-size:10.5pt">保险</span><span
        style=" font-size:10.5pt">为互联网专属产品，由美</span><span
        style=" font-size:10.5pt">亚财产</span><span
        style=" font-size:10.5pt">保险有限公司（以下简称“本</span><span
        style=" font-size:10.5pt">公司”）承保，面向全国（不含港澳台</span><span
        style=" font-size:10.5pt">）进行销售。本</span><span
        style=" font-size:10.5pt">保险</span><span
        style=" font-size:10.5pt">支持在线投保、核保、保单查询和报案等服务</span><span
        style=" font-size:10.5pt">。目前本</span><span
        style=" font-size:10.5pt">公司在上</span><span
        style=" font-size:10.5pt">海、北京、广东省（含深圳市）、江苏省和浙江省设有分支机构。本</span><span
        style=" font-size:10.5pt">公</span><span
        style=" font-size:10.5pt">司无分支机构的地区，可能无法向您提供及时的面对面线下服务，本</span><span
        style=" font-size:10.5pt">公司将通过电话及互联网通道在线为您提供</span><span
        style=" font-size:10.5pt">保单服务。如有任何疑问，可拨打本公司客户服务热线400-820-8858。</span><span
        style=" font-size:10.5pt"> </span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">2.</span><span
        style=" font-size:10.5pt">被保险人身故保险金受益人为被保险人的继承人。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">3.</span><span
        style=" font-size:10.5pt">本</span><span
        style=" font-size:10.5pt">保险</span><span
        style=" font-size:10.5pt">最早的生效时间为T+</span><span
        style=" font-size:10.5pt">1</span><span
        style=" font-size:10.5pt">，最晚为T+60的零时</span><span
        style=" font-size:10.5pt">（T是指投保成功日）</span><span
        style=" font-size:10.5pt">。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">4.</span><span
        style=" font-size:10.5pt; font-weight:normal">投保人须获得被保险人的同意，方可为其投保本保险。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">5.</span><span
        style=" font-size:10.5pt">被保险人年龄限制：</span><span
        style=" font-size:10.5pt">被保险人年龄为18-65周岁，连续投保可至70</span><span
        style=" font-size:10.5pt">周岁。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">6.</span><span
        style=" font-size:10.5pt">可投保</span><span
        style=" font-size:10.5pt">人</span><span
        style=" font-size:10.5pt">员</span><span
        style=" font-size:10.5pt">范围</span><span
        style=" font-size:10.5pt">（</span><span
        style=" font-size:10.5pt">须</span><span
        style=" font-size:10.5pt">同时满足以下两点）</span><span
        style=" font-size:10.5pt">：</span></p>
<p style="margin:0pt"><span style=" font-size:10.5pt">（1）</span><span
        style=" font-size:10.5pt">投保人所申报的符合所有投保条件的其于</span><span
        style=" font-size:10.5pt; font-weight:bold">中国大陆境内直接雇佣</span><span
        style=" font-size:10.5pt">的属于本保险接受投保职业类别的在岗全职雇员，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。</span>
</p>
<p style="margin:0pt"><span
        style=" font-size:10.5pt; font-weight:bold">本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期雇</span><span
        style=" font-size:10.5pt; font-weight:bold">佣</span><span
        style=" font-size:10.5pt; font-weight:bold">的情形。</span></p>
<p style="margin:0pt"><span
        style=" font-size:10.5pt">（2）中国大陆境内（不含港澳台）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常</span><span
        style=" font-size:10.5pt">住是指一年内在中国大陆境内的居住时间累计达到或超过183天。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">7.</span><a
        name="OLE_LINK6"></a><a name="OLE_LINK7"><span
            style=" font-size:10.5pt">约定的团体人员须全员投保，</span><span
            style=" font-size:10.5pt">且保险</span><span
            style=" font-size:10.5pt">合同成立时投保人数不低于3人。如被保险人</span><span
            style=" font-size:10.5pt">含职业</span><span
            style=" font-size:10.5pt">类别五或职业类别六，则被保险人人数应不低于5人。单张保单最高投保人数为1000人</span><span
            style="-aw-bookmark-end:OLE_LINK6"></span></a><span
        style=" font-size:10.5pt">。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">8.</span><a
        name="_Hlk46946477"><span style=" font-size:10.5pt">拒保</span><span
            style=" font-size:10.5pt">行业</span><span
            style=" font-size:10.5pt">：</span></a><span
        style=" font-size:10.5pt">渔业、森林砍伐业、矿业采石业、航运业以及涉及隧道作业、地下</span><span
        style=" font-size:10.5pt">作业、山洞作业、水上作业、易燃易爆物品生产和运输、武器弹药研究和开发、驯兽及凶猛动物养殖的职业活动的企业。</span>
</p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">9.</span><span
        style=" font-size:10.5pt">本公司在意外身故及伤残保障项下对所有被</span><span
        style=" font-size:10.5pt">保险人于任一次意外事故中累计所给付的赔偿金额以</span><span
        style=" font-size:10.5pt; font-weight:bold">每一意外事故总赔偿限额</span><span
        style=" font-size:10.5pt">为限。如在任</span><span
        style=" font-size:10.5pt">一</span><span
        style=" font-size:10.5pt">意外事故中，前述总赔偿限额低于按每一被保险人的保险金额给付的总赔偿金额，则本公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。</span>
</p>
<p style="margin:0pt"><span style=" font-size:10.5pt; font-weight:bold">每一意外事故总赔偿限额</span><span
        style=" font-size:10.5pt">为以下</span><span
        style=" font-size:10.5pt; font-weight:bold">两者较低者</span><span
        style=" font-size:10.5pt">：</span></p>
<p style="margin:0pt"><span style=" font-size:10.5pt">（1）</span><span
        style=" font-size:10.5pt">保险合同生效时所有被保险人对应的意外身故及伤残保障保险金额总和的40%；</span></p>
<p style="margin:0pt"><span style=" font-size:10.5pt">（2）</span><span
        style=" font-size:10.5pt">投保人所选计划对应意外身故及伤残保障保险金额最高者的10倍。 </span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">10.</span><a
        name="OLE_LINK1"></a><a name="OLE_LINK2"><span
            style=" font-size:10.5pt">本保险项下计划</span><span
            style=" font-size:10.5pt">一至计划八</span><span
            style=" font-size:10.5pt">的被保险人职业类别限制为1类至6类，计划九和计划十的被保险人职业类别限制为1类至4类。</span><span
            style=" font-size:10.5pt; font-weight:bold">具体职业请以职业分类表为准。本公司不接受职业分类表所列1类至6类职业以外的其他职业的人员投保保险计划的申请。</span></a>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
        style=" font-size:12pt">11.</span><span style="-aw-bookmark-end:OLE_LINK1"></span><span
        style="-aw-bookmark-end:OLE_LINK2"></span><span
        style=" font-size:10.5pt; font-weight:bold">投保人须按照任何约定团体成员的实际职业类别申请参保相应保险计划。如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准选择相应类别。如任何约定团体成员的实际职业类别为本保险拒保职业类别或高于所申请参保保险计划对应的职业类别，则该团体成员不属于本保险所承保的参保人员，本公司有权取消该团体成员的申报并在保险合同项下对该团体成员不承</span><span
        style=" font-size:10.5pt; font-weight:bold">担任何保险责任。  </span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">12.</span><span
        style=" font-size:10.5pt; font-weight:bold">如被保险人在保险有效期内发生职业变化，投保人或被保险人应于十</span><span
        style=" font-size:10.5pt; font-weight:bold">个</span><span
        style=" font-size:10.5pt; font-weight:bold">工作日内向本公司申请保全变更。如被保险人变更后的职业或工种依照职业分类表其危险程度降低时，则本公司自被保险人变更职业或工种之日起，按日比例退还变更前后保险费的差额；</span>
</p>
<p style="margin:0pt; text-indent:21pt"><span
        style=" font-size:10.5pt; font-weight:bold">如被保险人变更后的职业或工种依照职业分类表其危险增加时，投保人应自被保险人变更职业或工种之日起，按日比例补缴变更前后保险费的差额；</span>
</p>
<p style="margin:0pt; text-indent:21pt"><span
        style=" font-size:10.5pt; font-weight:bold">如被保险人变更后的职业或工种为职业分类表的拒保职业，则自被保险人变更职业或工种之日起，本公司对该被保险人所承担的保险责任终止，并按约定向投保人退还该被保险人对应的未满期保险费。</span>
</p>
<p style="margin:0pt; text-indent:21pt"><span
        style=" font-size:10.5pt; font-weight:bold">若被保险人的职业或工种发生变化，依照职业分类表其危险程度增加而未依前项约定向本公司申请变更而发生保险事故的，本公司有权取消该被保险人的申报并在保险合同项下对该团体成员不承担任何保险责任。
    </span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">13.</span><span
        style=" font-size:10.5pt; font-weight:normal">本保险每位</span><span
        style=" font-size:10.5pt; font-weight:normal">团体人员</span><span
        style=" font-size:10.5pt; font-weight:normal">限投一份保险计划，多投无效，不同计划重叠购买的无效。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">14.</span><span
        style=" font-size:10.5pt; font-weight:normal">同一职业类别的被保险人必须选择相同的保险计划。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">15.</span><span
        style=" font-size:10.5pt; font-weight:normal">本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T
        3608-2008）中规定的为准，如属于</span><span
        style=" font-size:10.5pt; font-weight:normal">在</span><span
        style=" font-size:10.5pt; font-weight:normal">距</span><span
        style=" font-size:10.5pt; font-weight:normal">坠落高度基准面5米及以上有可能坠落的高处进行作业</span><span
        style=" font-size:10.5pt; font-weight:normal">，前述被保险人应依法取得规定的特种作业证书。</span><span
        style=" font-size:10.5pt; font-weight:bold">若前述</span><span
        style=" font-size:10.5pt; font-weight:bold">被保险人从事高处作业时未系</span><span
        style=" font-size:10.5pt; font-weight:bold">绑</span><span
        style=" font-size:10.5pt; font-weight:bold">安全带</span><span
        style=" font-size:10.5pt; font-weight:bold">，则本公司不承担任何保险责任</span><span
        style=" font-size:10.5pt; font-weight:bold">。</span><span
        style=" font-size:10.5pt; font-weight:bold">对于职业类别为1</span><span
        style=" font-size:10.5pt; font-weight:bold">-</span><span
        style=" font-size:10.5pt; font-weight:bold">4类的被保险人，本保险不承保其任何5米及以上的</span><span
        style=" font-size:10.5pt; font-weight:bold">高处作业</span><span
        style=" font-size:10.5pt; font-weight:bold">。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">16.</span><span
        style=" font-size:10.5pt; font-weight:normal">被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。</span><span
        style=" font-size:10.5pt; font-weight:bold">若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。</span><span
        style=" font-size:10.5pt; font-weight:normal">特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。</span>
</p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">17.</span><span
        style=" font-size:10.5pt; font-weight:normal">若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，</span><span
        style=" font-size:10.5pt; font-weight:normal">则本公司对该被保险人于任一次意外事故中在意外医药补偿保障项下</span><span
        style=" font-size:10.5pt; font-weight:normal">支付的赔偿金额最高以该被保险人相应的保险金额为限。</span></p>
<p style="margin:0pt; text-indent:21pt"><span
        style=" font-size:10.5pt">若任何被保险人拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，</span><span
        style=" font-size:10.5pt">则本公司对该被保险人于任一次意外事故中在意外医药补偿保障项下</span><span
        style=" font-size:10.5pt">支付的赔偿金额最高以该被保险人相应保险金额的百分之一百零五（105%）为限，但须扣除该被保险人任何已取得的医药费用补偿。
    </span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">18.</span><span
        style=" font-size:10.5pt; font-weight:bold">本保险所称的医院若处于中国大陆境内，</span><span
        style=" font-size:10.5pt; font-weight:bold">则医院</span><span
        style=" font-size:10.5pt; font-weight:bold">必须是经国家卫生部门评审确定的二级以上（含二级）公立医院。</span></p>
<p style="margin:0pt; orphans:0; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt; font-weight:bold">本保险所称的医院不包括下列医院：1）位于北京市平谷区、房山区、怀柔区、密云县的任何医院；2）河北省邯郸市馆陶县人民医院、承德市兴隆县的任何医院；3）河南省内黄县第二人民医院、内黄县人民医院、内黄县中医院、新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、河南许昌人民医院、河南濮阳县第二人民医院、河南省开封市通许人民医院、商水县人民</span><span
        style=" font-size:10.5pt; font-weight:bold">医院；4）山东省莱州市人民医院、莱州市中医院、莱州市郭家</span><span
        style=" font-size:10.5pt; font-weight:bold">店中心</span><span
        style=" font-size:10.5pt; font-weight:bold">卫生院、荣成市中医院、烟台市中医院、栖霞市的任何医院、滨州市的任何医院、威海市的任何医院、金乡县的任何医院；5）四川省的雅安市雨城区人民医院、雅安市第二人民医院、宜宾市的任何医院；6）吉林省长春市中心医院、四平市的任何医院；7）福建中医药大学附属南平人民医院、福建医科大学附属南平第一医院；8）安徽省宿州中</span><span
        style=" font-size:10.5pt; font-weight:bold">煤矿建</span><span
        style=" font-size:10.5pt; font-weight:bold">总医院；9）甘肃省宁县人民医院。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">19.</span><span
        style=" font-size:10.5pt; font-weight:bold">本保险为团体保险，投保人不得以任何方式销售给第三方</span><span
        style=" font-size:10.5pt; font-weight:bold">（第三方包括但不限于被保险人本人）</span><span
        style=" font-size:10.5pt; font-weight:normal">。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">20.</span><span
        style=" font-size:10.5pt; font-weight:bold">若本公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致本公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则本公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。</span>
</p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">21.</span><span
        style=" font-size:10.5pt; font-weight:bold">本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。</span>
</p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">22.</span><span
        style=" font-size:10.5pt; font-weight:bold">投保人未能披露与本保险相关之重大事实可能导致本公司不承担保险责任</span><span
        style=" font-size:10.5pt; font-weight:normal">。重大事实系指可能影响保险公司风险评估或接受投保</span><span
        style=" font-size:10.5pt; font-weight:normal">申请</span><span
        style=" font-size:10.5pt; font-weight:normal">与否之事实。如果投保人不能确定某些事实是否属于应披露之重大事实，请予以披露。</span>
</p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">23.</span><span
        style=" font-size:10.5pt; font-weight:normal">本</span><span
        style=" font-size:10.5pt; font-weight:normal">保险</span><span
        style=" font-size:10.5pt; font-weight:bold">仅提供电子</span><span
        style=" font-size:10.5pt; font-weight:bold">版本的</span><span
        style=" font-size:10.5pt; font-weight:bold">保单</span><span
        style=" font-size:10.5pt; font-weight:normal">，根据</span><span
        style=" font-size:10.5pt; font-weight:normal">预留的电子邮件地址发送</span><span
        style=" font-size:10.5pt; font-weight:normal">电子</span><span
        style=" font-size:10.5pt; font-weight:normal">版本的</span><span
        style=" font-size:10.5pt; font-weight:normal">保单，</span><span
        style=" font-size:10.5pt; font-weight:normal">投保人可登录</span><a
        href="https://www-401.aiginsurance.com.cn/CIRC/accident_policy_enquiry.asp"><span
            style="color:#0000ff; font-size:10.5pt; font-weight:normal; text-decoration:underline">https://www-401.aiginsurance.com.cn/CIRC/accident_policy_enquiry.asp</span></a><span
        style=" font-size:10.5pt; font-weight:bold"> </span><span
        style=" font-size:10.5pt; font-weight:normal">进行保单</span><span
        style=" font-size:10.5pt; font-weight:normal">验真</span><span
        style=" font-size:10.5pt; font-weight:normal">。</span></p>
<p style="margin:0pt; text-indent:0pt"><span style=" font-size:12pt">24.</span><span
        style=" font-size:10.5pt">美</span><span
        style=" font-size:10.5pt">亚财产</span><span
        style=" font-size:10.5pt">保险有限公司综合偿付能力充足率达到监管要求，且风险综合评级提示操作、战略、声誉和流动风险较小，具体偿付能力指标和风险综合评级结果请</span><span
        style=" font-size:10.5pt">详见</span><a
        href="https://www.aig.com.cn/individuals/information-disclosures/specific-info/solvency-info-disclosure"><span
            style="color:#0000ff; font-size:10.5pt; text-decoration:underline">https://www.aig.com.cn/individuals/information-disclosures/specific-info/solvency-info-disclosure</span></a>
</p>
<p style="margin:0pt; orphans:0; text-indent:0pt; widows:0"><span
        style=" font-size:12pt">25.</span><span
        style=" font-size:10.5pt">适用条款</span><span
        style=" font-size:10.5pt">及批单</span><span
        style=" font-size:10.5pt">：</span><span
        style=" font-size:10.5pt">《</span><span
        style=" font-size:10.5pt">美亚团体意外伤害保险（2021年第一版）（互联网专属）</span><span
        style=" font-size:10.5pt">》</span><span
        style=" font-size:10.5pt">（注册编号：C00003932312021121719483）</span><span
        style=" font-size:10.5pt">、《</span><span
        style=" font-size:10.5pt">美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）</span><span
        style=" font-size:10.5pt">》</span><span
        style=" font-size:10.5pt">（注册编号：C00003932522021122436913） </span><span
        style=" font-size:10.5pt">、《</span><span
        style=" font-size:10.5pt">美亚附加不承保特定医院条款（2021年第二版）</span><span
        style=" font-size:10.5pt">》</span><span
        style=" font-size:10.5pt">（注册编号：C00003931922021072908951）</span><span
        style=" font-size:10.5pt">、《</span><span
        style=" font-size:10.5pt">美亚附加特种作业限制条款 （2021年第二版）（互联网专属）</span><span
        style=" font-size:10.5pt">》</span><span
        style=" font-size:10.5pt">（注册编号：C00003932322021122437203） </span><span
        style=" font-size:10.5pt">、《</span><span
        style=" font-size:10.5pt">美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）</span><span
        style=" font-size:10.5pt">》</span><span
        style=" font-size:10.5pt">（注册编号：C00003932322021122437123） </span><span
        style=" font-size:10.5pt">、《</span><span
        style=" font-size:10.5pt">美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）</span><span
        style=" font-size:10.5pt">》</span><span
        style=" font-size:10.5pt">（注册编号：C00003931922021072908971）</span><span
        style=" font-size:10.5pt">、《</span><span
        style=" font-size:10.5pt">美亚附加经济制裁责任免除条款</span><span
        style=" font-size:10.5pt">》</span><span
        style=" font-size:10.5pt">（注册编号：C00003931922019052907382</span><span
        style=" font-size:10.5pt">）</span><span
        style=" font-size:10.5pt">。</span></p>
<p style="margin:0pt; orphans:0; text-indent:0pt; widows:0"><span
        style=" font-size:12pt">26.</span><span
        style=" font-size:10.5pt">所有的保险责任及条款均以与本公司正式订立保险合同的规定为准。</span></p>
<p style="margin:0pt"><span style=" font-size:10.5pt">&#xa0;</span></p>
<p style="margin:0pt"><a name="OLE_LINK4"></a><a name="OLE_LINK5"><span
            style=" font-size:10.5pt; font-weight:normal">【</span><span
            style="background-color:#ffffff; color:#3f3f3f; font-size:10.5pt; font-weight:bold">发票须知】</span></a>
</p>
<p style="margin:0pt; orphans:0; widows:0"><span style=" font-size:10.5pt">1.本</span><span
        style=" font-size:10.5pt">保险</span><span
        style=" font-size:10.5pt">提供电子普票或者纸质专票，均须在投保渠道申请。</span></p>
<p style="margin:0pt; orphans:0; widows:0"><span
        style=" font-size:10.5pt">2.电子发票效力等同于纸质发票。电子普票一般在申请30分钟内发送至投保时预留的电子邮箱；单位投保的，电子普票仅展示纳税人名称及纳税人识别号。</span>
</p>
<p style="margin:0pt; orphans:0; widows:0"><span
        style=" font-size:10.5pt">纸质专票在保单生效后于7-14个工作日内寄送，小规模纳税人不能申请专票。</span></p>
<p style="margin:0pt; orphans:0; widows:0"><span
        style=" font-size:10.5pt; font-weight:bold">特别提示：单次申请的发票</span><span
        style=" font-size:10.5pt; font-weight:bold">合计开票金额低于500元的，使用到付</span><span
        style=" font-size:10.5pt; font-weight:bold">方式</span><span
        style=" font-size:10.5pt; font-weight:bold">邮寄。</span></p>
<p style="margin:0pt; orphans:0; widows:0"><span style=" font-size:10.5pt">3.对于</span><span
        style=" font-size:10.5pt; font-weight:bold">开具纸质专票的保单，在发生保全减人或退保时，</span><span
        style=" font-size:10.5pt; font-weight:bold">发票已抵扣的，须将</span><span
        style=" font-size:10.5pt; font-weight:bold">《开具红字增值税专用发票信息表》</span><span
        style=" font-size:10.5pt; font-weight:bold">电子版（加盖发票专用章）发送至电子邮箱：</span><a
        style="color:#000000" href="mailto:OPS-CN@AIG.COM" target="_blank"><span
            style=" font-size:10.5pt; font-weight:bold">OPS-CN@AIG.COM</span></a><span
        style=" font-size:10.5pt; font-weight:bold">；发票未抵扣的，</span><span
        style=" font-size:10.5pt; font-weight:bold">须将发票原件交回保险公司，并承担由此产生的快递费用，</span><span
        style=" font-size:10.5pt">快递收件信息：</span></p>
<p style="margin:0pt; orphans:0; widows:0"><span style=" font-size:10.5pt">&#xa0;</span></p>
<table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:475.65pt">
    <tr>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:67.2pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:12pt; font-weight:bold; text-decoration:underline">分公司</span>
            </p>
        </td>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:223.05pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:12pt; font-weight:bold; text-decoration:underline">地址</span>
            </p>
        </td>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:60.1pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:12pt; font-weight:bold; text-decoration:underline">收件人名称</span>
            </p>
        </td>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.35pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:12pt; font-weight:bold; text-decoration:underline">联系电话</span>
            </p>
        </td>
    </tr>
    <tr>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:67.2pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:10.5pt">北京分公司</span></p>
        </td>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:223.05pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:10.5pt">北京市朝阳区建国路79 号华贸中心2 号写字楼10 层05，06号美亚保险</span></p>
        </td>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:60.1pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:10.5pt">B</span><span
                    style=" font-size:10.5pt">J CPS</span></p>
        </td>
        <td
            style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.35pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
                    style=" font-size:10.5pt">0</span><span
                    style=" font-size:10.5pt">10-59692888</span></p>
        </td>
    </tr>
</table>
<p style="margin:0pt; orphans:0; widows:0"><span style=" font-size:10.5pt">&#xa0;</span></p>
<p style="background-color:#ffffff; margin:0pt"><span style="-aw-bookmark-end:OLE_LINK4"></span><span
        style="-aw-bookmark-end:OLE_LINK5"></span><span
        style="color:#3f3f3f; font-size:10.5pt; font-weight:bold">&#xa0;</span></p>
<p style="background-color:#ffffff; margin:0pt"><a name="OLE_LINK3"><span
            style="background-color:#ffffff; color:#3f3f3f; font-size:10.5pt; font-weight:bold">【</span><span
            style="background-color:#ffffff; color:#3f3f3f; font-size:10.5pt; font-weight:bold">理赔须知</span><span
            style="background-color:#ffffff; color:#3f3f3f; font-size:10.5pt; font-weight:bold">】</span></a>
</p>
<p style="background-color:#ffffff; margin:0pt"><span style="-aw-bookmark-end:OLE_LINK3"></span><span
        style="color:#3f3f3f; font-size:10.5pt">1</span><span
        style="color:#3f3f3f; font-size:10.5pt">.</span><span
        style="color:#3f3f3f; font-size:10.5pt">保险事故通知：</span><span
        style="color:#3f3f3f; font-size:10.5pt">投保人</span><span
        style="color:#3f3f3f; font-size:10.5pt">、被保险人或受益人知道保险事故发生后，应当在 10 日内</span><span
        style=" font-size:10.5pt">（</span><span
        style=" font-size:10.5pt; font-weight:bold">身故/伤残案件</span><span
        style=" font-size:10.5pt; font-weight:bold">须尽早报案（24小时内）</span><span
        style=" font-size:10.5pt">，如果未及时报案导致事故性质无法认定，可能会影响理赔结论）</span><span
        style="color:#3f3f3f; font-size:10.5pt">通知保险公司</span><span
        style="color:#3f3f3f; font-size:10.5pt">（</span><span
        style=" font-size:10.5pt">美亚财险</span><span
        style=" font-size:10.5pt">客服热线</span><span
        style=" font-size:10.5pt">400-820-8858</span><span
        style=" font-size:10.5pt">）</span><span
        style="color:#3f3f3f; font-size:10.5pt">。</span><span
        style="color:#3f3f3f; font-size:10.5pt; font-weight:bold">若</span><span
        style="color:#3f3f3f; font-size:10.5pt; font-weight:bold">投保人</span><span
        style="color:#3f3f3f; font-size:10.5pt; font-weight:bold">、被保险人或受益人故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，</span><span
        style="color:#3f3f3f; font-size:10.5pt; font-weight:bold">保险公司</span><span
        style="color:#3f3f3f; font-size:10.5pt; font-weight:bold">对无法确定的部分，不承担给付保险金的责任</span><span
        style="color:#3f3f3f; font-size:10.5pt">，但</span><span
        style="color:#3f3f3f; font-size:10.5pt">保险公司</span><span
        style="color:#3f3f3f; font-size:10.5pt">通过其他途径已经及时知道或者应</span><span
        style="color:#3f3f3f; font-size:10.5pt">当及时</span><span
        style=" font-size:10.5pt">知道</span><span
        style="color:#3f3f3f; font-size:10.5pt">保</span><span
        style="color:#3f3f3f; font-size:10.5pt">险事故发生或者虽未及时通知但不影响保</span><span
        style="color:#3f3f3f; font-size:10.5pt">司确定</span><span
        style="color:#3f3f3f; font-size:10.5pt">保险事故的性质、原因、损失程度的除外。</span></p>
<p style="background-color:#ffffff; margin:0pt"><span
        style="color:#3f3f3f; font-size:10.5pt">2</span><span
        style="color:#3f3f3f; font-size:10.5pt">.资料提交</span><span
        style="color:#3f3f3f; font-size:10.5pt">：</span><span
        style="color:#3f3f3f; font-size:10.5pt">理赔专员会根据保险事故类型和申请金额指引客户提供电子版或纸质版资料</span><span
        style="color:#3f3f3f; font-size:10.5pt">。</span></p>
<p style="background-color:#ffffff; margin:0pt"><span
        style="color:#3f3f3f; font-size:10.5pt">3</span><span
        style="color:#3f3f3f; font-size:10.5pt">.</span><span
        style="color:#3f3f3f; font-size:10.5pt">理赔审核：</span><span
        style="color:#3f3f3f; font-size:10.5pt">美亚财险在收到完整</span><span
        style="color:#3f3f3f; font-size:10.5pt">索赔资料的前提下，</span><span
        style="color:#3f3f3f; font-size:10.5pt">于5个工作日内</span><span
        style="color:#3f3f3f; font-size:10.5pt">作出</span><span
        style="color:#3f3f3f; font-size:10.5pt">核定，并于</span><span
        style="color:#3f3f3f; font-size:10.5pt">作出</span><span
        style="color:#3f3f3f; font-size:10.5pt">核定后1</span><span
        style="color:#3f3f3f; font-size:10.5pt">个工作日内通知申请人；</span><span
        style="color:#3f3f3f; font-size:10.5pt">如</span><span
        style="color:#3f3f3f; font-size:10.5pt">遇复杂</span><span
        style="color:#3f3f3f; font-size:10.5pt">情形，可将核定期限延展至30日。</span></p>
<p style="background-color:#ffffff; margin:0pt"><span
        style="color:#3f3f3f; font-size:10.5pt">4</span><span
        style="color:#3f3f3f; font-size:10.5pt">.</span><span
        style="color:#3f3f3f; font-size:10.5pt">结案支付：</span><span
        style="color:#3f3f3f; font-size:10.5pt">美亚财险将理赔结果通知被保险人/受益人/投保人，属于保险责任的案件将及时支付保险金。</span>
</p>
</div>`
